import { render } from "./businessOpportunityDashboard.vue?vue&type=template&id=22ca9b93&scoped=true"
import script from "./businessOpportunityDashboard.vue?vue&type=script&lang=js"
export * from "./businessOpportunityDashboard.vue?vue&type=script&lang=js"

import "./businessOpportunityDashboard.vue?vue&type=style&index=0&id=22ca9b93&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ca9b93"]])

export default __exports__